import moment from "moment";

export const formatDate = (isoString) => {
  return moment(isoString).format("DD MMMM, YYYY - hh:mmA").toLowerCase();
};
